var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.25012C7.40625 1.25012 1.25 7.40637 1.25 15.0001C1.25 22.5939 7.40625 28.7501 15 28.7501C22.5938 28.7501 28.75 22.5939 28.75 15.0001C28.75 7.40637 22.5938 1.25012 15 1.25012ZM20.96 12.6751C21.0697 12.5497 21.1533 12.4035 21.2057 12.2453C21.2582 12.0871 21.2784 11.92 21.2653 11.7539C21.2522 11.5877 21.206 11.4258 21.1295 11.2778C21.0529 11.1297 20.9475 10.9985 20.8194 10.8918C20.6914 10.7851 20.5433 10.7051 20.3839 10.6565C20.2244 10.6078 20.0569 10.5916 19.8911 10.6087C19.7253 10.6257 19.5646 10.6758 19.4184 10.7559C19.2723 10.836 19.1436 10.9446 19.04 11.0751L13.665 17.5239L10.8837 14.7414C10.648 14.5137 10.3322 14.3877 10.0045 14.3905C9.67675 14.3934 9.36324 14.5248 9.13148 14.7566C8.89972 14.9884 8.76826 15.3019 8.76541 15.6296C8.76256 15.9574 8.88855 16.2731 9.11625 16.5089L12.8663 20.2589C12.9891 20.3816 13.1361 20.4774 13.298 20.5402C13.4599 20.603 13.6331 20.6313 13.8066 20.6234C13.9801 20.6156 14.15 20.5716 14.3055 20.4944C14.4611 20.4172 14.5988 20.3085 14.71 20.1751L20.96 12.6751Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6ede5b965d381b0a3456e3a46653da22.svg";
export { ForwardRef as ReactComponent };